import { isProd } from "src/env/enviroment";

const getPaymentWidgetBaseUrl = () => {
  return isProd ? 'https://msi-widget.msimga.com' : 'https://test-widget-msimga.azurewebsites.net';
}

export const paymentWidgetConfig = {
  url: `${getPaymentWidgetBaseUrl()}/msiInclude.js?container=msiInsurance`,
  global: {
    custLoginId: 341,
    custName: 'Guarantors',
    paymentMethodsAllowed: ['CC', 'ACH'],
    widget: 'payment',
  },
  defaultThemeConfig: {
    textColor: '#1D1D1D',
    buttonTextColor: '#1D1D1D',
    primaryColor: '#FFFFFF',
    secondaryColor: '#C2CD23',
    backgroundColor: '#FFFFFF',
    inputBackgroundColor: 'rgb(234, 246, 236)',
    inputBoxShadow: 'none',
    inputTextColor: '#1D1D1D',
    borderRadius: '4px',
    fontFamily: 'Roboto, sans-serif',
    paymentFields: {
      creditCard: {
        ccButtonName: 'Credit Card',
        ccName: {
          label: 'Name on card',
          placeholder: 'Name on card *',
        },
        ccNumber: {
          label: 'Card number',
          placeholder: 'Card number *',
        },
        ccExpiration: {
          label: 'Expiration date',
          placeholderMonth: 'MM',
          placeholderYear: 'YY*',
        },
        ccCVV: {
          label: 'CVV',
          placeholder: 'CVV *',
          tooltip: 'What is this?',
        },
      },
      ach: {
        achButtonName: 'Bank Transfer',
        bankName: {
          label: 'Banking Institution',
        },
        accountName: {
          label: 'Account Name',
        },
        accountType: {
          label: 'Account Type',
        },
        accountEnding: {
          label: 'Account Ending In',
        },
      },
    },
  },
};
